export enum Document {
  CPF = 'cpf',
  CNPJ = 'cnpj',
  DNI = 'dni',
}
